import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button,
  Input,
} from 'antd'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormAboutPakde = ({
  detail, onSubmit,
  form, isSubmit,
}) => {
  const { getFieldDecorator, validateFields } = form
  return (
    <Card>
      <Form
        {...formItemLayout}
        onSubmit={(e) => {
          e.preventDefault()
          validateFields((err, values) => {
            if (!err) {
              onSubmit(values)
            }
          })
        }}
      >
        <Form.Item label="TItle">
          {getFieldDecorator('title', {
            initialValue: detail.data.title,
            rules: [{ required: true }],
          })(
            <Input placeholder="Title" />,
          )}
        </Form.Item>
        <Form.Item label="Short Description">
          {getFieldDecorator('content', {
            initialValue: detail.data.content,
            rules: [{ required: true }],
          })(
            <Input placeholder="Short Description" />,
          )}
        </Form.Item>

        <Form.Item {...tailLayout} className="btn-primary-wrapper">
          <Button onClick={() => history.push('/web-management/penjelasan-simpan')} className="mr-2" style={{ display: 'inline-block' }}>Cancel</Button>
          <Button type="primary" loading={isSubmit} htmlType="submit">Submit Change</Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

FormAboutPakde.propTypes = {
  detail: PropTypes.object,
  onSubmit: PropTypes.func,
  form: PropTypes.any,
  isSubmit: PropTypes.bool,
}

export default Form.create({ name: 'aboutPakdeForm' })(FormAboutPakde)
